import { MAX_MOBILE_WIDTH } from 'settings';
import { AppDispatch } from 'store';
import setCustomerDeviceTypeOperation from 'store/app/operation/setCustomerDeviceTypeOperation';
import { CustomerDeviceType } from '../types';

const detectCustomerDeviceOperation = () => (dispatch: AppDispatch) => {
  const isMobile = window.matchMedia(`only screen and (max-width: ${MAX_MOBILE_WIDTH}px)`).matches;
  const isVertical = window.matchMedia(`(orientation: portrait)`).matches;
  const customerDevice = isMobile ? CustomerDeviceType.MOBILE : CustomerDeviceType.DESKTOP;
  dispatch(setCustomerDeviceTypeOperation(customerDevice, isVertical));
};

export default detectCustomerDeviceOperation;
